<template>
  <div class="import-page" v-loading="loading">

    <el-button class="import-page-upload-btn" type="danger" size="mini" @click="onClickUpload()">{{ $t('import.s6') }}</el-button>

    <el-empty :description="$t('el.cascader.noData')" v-if="nodata==2">
      <el-button type="danger" size="mini" @click="onClickUpload()">{{ $t('import.s6') }}</el-button>
    </el-empty>

    <div class="import-content" v-if="nodata==1">
      <el-tabs v-model="activeName" type="card" @tab-click="changetabs()">
        <el-tab-pane :label="tabname[0]" name="first">
          <div class="tablebox">
            <el-table
              :cell-style="getTableCellStyle"
              :data="table1" 
              tooltip-effect="dark" 
              style="width: 100%"
              @expand-change="getProductList"
              :expand-row-keys="expands"
              :row-key="getRowKeys"
              :key="0"
              size="mini"
            >
              <el-table-column width="30" type="expand">
                <template slot-scope="scope">
                  <div class="tablebox">
                    <el-table
                      :cell-style="getTableCellStyle"
                      :data="skudata[scope.row.index]"
                      tooltip-effect="dark"
                      v-loading="tableloading1"
                      style="width: 100%"
                      border
                      size="mini"
                      stripe
                    >
                      <el-table-column prop="assetId" label="ASSETID" width="100" show-overflow-tooltip></el-table-column>
                      <el-table-column :label="$t('jgjk.s266')" show-overflow-tooltip>
                        <template slot-scope="scope">
                          <a :href="scope.row.URL" target="_blank">{{ scope.row.skuMap == null || scope.row.skuMap == ''? '无套餐' : scope.row.skuMap  }}</a>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="Import ID" prop="ImportID" width="100" show-overflow-tooltip></el-table-column>
              <el-table-column :label="$t('jgjk.s15')" prop="AssetTitle" show-overflow-tooltip>
                <template slot-scope="scope">
                  <a :href="scope.row.URL" target="_blank">{{ scope.row.AssetTitle }}</a>
                </template>
              </el-table-column>
              <el-table-column :label="$t('jgjk.s12')" width="140">
                <template slot-scope="scope">
                  <i class="channelicon" :class="scope.row.channelicon"></i>
                </template>          
              </el-table-column>
              <el-table-column :label="$t('activebrand.t50')" width="200" show-overflow-tooltip>
                <template slot-scope="scope">
                  <a :href="scope.row.ShopURL" target="_blank">{{ scope.row.ShopName }}</a>
                </template>
              </el-table-column>
              <el-table-column sortable='custom' prop="Count" :label="$t('SPU.s10')" width="120"></el-table-column>
              <el-table-column sortable='custom' prop="inserttime" :label="$t('import.s7')" width="130" show-overflow-tooltip></el-table-column>
              <el-table-column :label="$t('activebrand.t37')" width="80">
                <template slot-scope="scope">
                  <el-popconfirm :title="$t('import.s8')" @confirm="updateStatus(scope.row, 1)">
                    <el-button slot="reference" class="delete-icon-btn" type="button">
                      <i class="el-icon-video-pause"></i>
                    </el-button>
                  </el-popconfirm>
                  <el-popconfirm :title="$t('import.s9')" @confirm="updateStatus(scope.row, 2)">
                    <el-button slot="reference" class="delete-icon-btn" type="button">
                      <i class="el-icon-delete"></i>
                    </el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        
        <el-tab-pane :label="tabname[1]" name="second">
          <div class="tablebox">
            <el-table
              :cell-style="getTableCellStyle"
              :data="table2" 
              tooltip-effect="dark" 
              style="width: 100%"
              @expand-change="getProductList"
              :expand-row-keys="expands"
              :row-key="getRowKeys"
              :key="1"
              size="mini"
            >
              <el-table-column width="30" type="expand">
                <template slot-scope="scope">
                  <div class="tablebox">
                    <el-table
                      :cell-style="getTableCellStyle"
                      :data="skudata[scope.row.index]"
                      v-loading="tableloading1"
                      tooltip-effect="dark" 
                      style="width: 100%"
                      border
                      size="mini"
                      stripe
                    >
                      <el-table-column prop="assetId" label="ASSETID" width="100" show-overflow-tooltip></el-table-column>
                      <el-table-column :label="$t('jgjk.s266')" show-overflow-tooltip>
                        <template slot-scope="scope">
                          <a :href="scope.row.URL" target="_blank">{{ scope.row.skuMap == null || scope.row.skuMap == '' ? '无套餐' : scope.row.skuMap }}</a>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="Import ID" prop="ImportID" width="130" show-overflow-tooltip></el-table-column>
              <el-table-column :label="$t('jgjk.s15')" show-overflow-tooltip>
                <template slot-scope="scope">
                  <a :href="scope.row.URL" target="_blank">{{ scope.row.AssetTitle }}</a>
                </template>
              </el-table-column>
              <el-table-column :label="$t('jgjk.s12')" width="140">
                <template slot-scope="scope">
                  <i class="channelicon" :class="scope.row.channelicon"></i>
                </template>          
              </el-table-column>
              <el-table-column :label="$t('activebrand.t50')" width="200" show-overflow-tooltip>
                <template slot-scope="scope">
                  <a :href="scope.row.ShopURL" target="_blank">{{ scope.row.ShopName }}</a>
                </template>
              </el-table-column>
              <el-table-column sortable='custom' prop="Count" :label="$t('SPU.s10')" width="120"></el-table-column>
              <el-table-column sortable='custom' prop="inserttime" :label="$t('import.s7')" width="130" show-overflow-tooltip></el-table-column>
              <el-table-column :label="$t('activebrand.t37')" width="80">
                <template slot-scope="scope">
                  <el-popconfirm :title="$t('import.s10')" @confirm="updateStatus(scope.row, 0)">
                    <el-button slot="reference" class="delete-icon-btn" type="button">
                      <i class="el-icon-refresh-right"></i>
                    </el-button>
                  </el-popconfirm>
                  <el-popconfirm :title="$t('import.s9')" @confirm="updateStatus(scope.row, 2)">
                    <el-button slot="reference" class="delete-icon-btn" type="button">
                      <i class="el-icon-delete"></i>
                    </el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </div>          
        </el-tab-pane>

        <el-tab-pane :label="tabname[2]" name="third">
          <div class="tablebox">
            <el-table
              :cell-style="getTableCellStyle"
              :data="table3" 
              tooltip-effect="dark" 
              style="width: 100%"
              @expand-change="getProductList"
              :expand-row-keys="expands"
              :row-key="getRowKeys"
              :key="2"
              size="mini"
            >
              <el-table-column width="30" type="expand">
                <template slot-scope="scope">
                  <div class="tablebox">
                    <el-table
                      :cell-style="getTableCellStyle"
                      :data="skudata[scope.row.index]"
                      v-loading="tableloading1"
                      tooltip-effect="dark" 
                      style="width: 100%"
                      border
                      size="mini"
                      stripe
                    >
                      <el-table-column prop="assetId" label="ASSETID" width="100" show-overflow-tooltip></el-table-column>
                      <el-table-column :label="$t('jgjk.s266')" show-overflow-tooltip>
                        <template slot-scope="scope">
                          <a :href="scope.row.URL" target="_blank">{{ scope.row.skuMap == null || scope.row.skuMap == '' ? '无套餐' : scope.row.skuMap  }}</a>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="Import ID" prop="ImportID" width="130" show-overflow-tooltip></el-table-column>
              <el-table-column :label="$t('jgjk.s15')" show-overflow-tooltip>
                <template slot-scope="scope">
                  <a :href="scope.row.URL" target="_blank">{{ scope.row.AssetTitle }}</a>
                </template>
              </el-table-column>
              <el-table-column :label="$t('jgjk.s12')" width="140">
                <template slot-scope="scope">
                  <i class="channelicon" :class="scope.row.channelicon"></i>
                </template>          
              </el-table-column>
              <el-table-column :label="$t('activebrand.t50')" width="200" show-overflow-tooltip>
                <template slot-scope="scope">
                  <a :href="scope.row.ShopURL" target="_blank">{{ scope.row.ShopName }}</a>
                </template>
              </el-table-column>
              <el-table-column sortable='custom' prop="Count" :label="$t('SPU.s10')" width="120"></el-table-column>
              <el-table-column sortable='custom' prop="inserttime" :label="$t('import.s7')" width="130" show-overflow-tooltip></el-table-column>
              <el-table-column :label="$t('activebrand.t37')" width="80">
                <template slot-scope="scope">
                  <el-popconfirm :title="$t('import.s10')" @confirm="updateStatus(scope.row, 0)">
                    <el-button slot="reference" class="delete-icon-btn" type="button">
                      <i class="el-icon-refresh-right"></i>
                    </el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </div>          
        </el-tab-pane>

        <el-tab-pane :label="tabname[3]" name="four">
          <div class="tablebox">
            <el-table
              :cell-style="getTableCellStyle"
              :data="table4" 
              tooltip-effect="dark" 
              style="width: 100%"
              size="mini"
            >
              <el-table-column label="Import ID" prop="ImportID" width="130" show-overflow-tooltip></el-table-column>
              <el-table-column :label="$t('import.s17')" show-overflow-tooltip>
                <template slot-scope="scope">
                  <a :href="scope.row.URL" target="_blank">{{ scope.row.URL }}</a>
                </template>
              </el-table-column>
              <el-table-column :label="$t('import.s7')" prop="inserttime" width="200" show-overflow-tooltip></el-table-column>
            </el-table>
          </div>
        </el-tab-pane>

        <el-tab-pane :label="tabname[4]" name="five">
          <div class="tablebox">
            <el-table
              :cell-style="getTableCellStyle"
              :data="table5" 
              tooltip-effect="dark" 
              style="width: 100%"
              size="mini"
            >
              <el-table-column label="Import ID" prop="ImportID" width="130" show-overflow-tooltip></el-table-column>
              <el-table-column :label="$t('import.s17')" show-overflow-tooltip>
                <template slot-scope="scope">
                  <a :href="scope.row.URL" target="_blank">{{ scope.row.URL }}</a>
                </template>
              </el-table-column>
              <el-table-column :label="$t('activebrand.t35')" width="300" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ scope.row.Reason }}
                  <el-tooltip v-if="scope.row.Descs" class="item" effect="dark" :content="scope.row.Descs" placement="top">
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column :label="$t('import.s7')" prop="inserttime" width="200" show-overflow-tooltip></el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="pagewrap">
        <el-pagination
          small
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          popper-class="pagesizeclass"
          :page-sizes="[25, 50, 100]"
          :page-size="pagesize"
          layout="total, prev, pager, next, sizes"
          :total="pagingtotal">
        </el-pagination>      
      </div>
    </div>
  
    <el-dialog
      custom-class="editskulink-datafeedback"
      :title="$t('import.s19')"
      :visible.sync="showdialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="true"
      :append-to-body="true"
      @close="showchannelicon = false; updatesuccessful=false; uploadurls=''; urlslength=0">
      <div class="editskulink-body" v-if="false === updatesuccessful" v-loading.fullscreen.lock="importloading">
        <el-input
          v-if="!nochannel"
          type="textarea"
          :rows="10"
          :placeholder="$t('import.s11')"
          resize="none"
          v-model="uploadurls"
          @input.native="onInputChange">
        </el-input>
        <p v-if="!nochannel">{{ $t('import.s12') }} {{ urlslength }} {{ $t('import.s13') }}</p>
        <div class="import-sitelogo" v-if="showchannelicon">
          <h2 v-if="!nochannel">{{ $t('import.s14') }}</h2>
          <h2 v-if="nochannel">{{ $t('import.s15') }}</h2>
          <img v-if="channel.taobao" src="@/assets/img/channelicons/01_taobao_100x100.png" />
          <img v-if="channel.tmall" src="@/assets/img/channelicons/02_tmall_100x100.png" />
          <img v-if="channel.jd" src="@/assets/img/channelicons/03_jd_100x100.png" />
          <img v-if="channel.pdd" src="@/assets/img/channelicons/30_pdd_100x100.png" />
          <img v-if="channel.vipcom" src="@/assets/img/channelicons/10_vipcom_100x100.png" />
          <img v-if="channel.kaola" src="@/assets/img/channelicons/17_kaola_100x100.png" />
          <img v-if="channel.douyin" src="@/assets/img/channelicons/45_douyin_100x100.png" />
        </div>
      </div>
      <span slot="footer" v-if="false === updatesuccessful" class="dialog-footer">
        <el-button size="mini" @click="showchannelicon = false; showdialog = false; uploadurls=''">{{$t('dsfx.t32')}}</el-button>
        <el-button v-if="!nochannel" size="mini" type="primary" @click="uploadSku()">{{$t('dsfx.t33')}}</el-button>
      </span>
      <div class="editskulink-body" v-if="true === updatesuccessful">
        <el-result icon="success" :title="$t('import.s18')">
          <template slot="extra">
            <p>{{ $t('import.s16') }}</p>
          </template>
        </el-result>
      </div>
      <span slot="footer" v-if="true === updatesuccessful" class="dialog-footer">
        <el-button size="mini" type="primary" @click="showdialog = false; uploadurls=''">{{$t('dsfx.t33')}}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data(){
    return{
      current: this.getCurrentInfo(),
      showdata: false,
      loading: false,
      importloading: false,
      showdialog: false,
      uploadurls: '',
      urlsdata: [],
      urlslength: 0,
      activeName: 'first',
      updatesuccessful: false,
      showchannelicon: true,
      channel:{
        taobao: false,
        tmall: false,
        jd: false,
        pdd: false,
        kaola: false,
        vipcom: false,
        douyin: false
      },
      nochannel: false,
      getRowKeys(row){
        return row.index
      },
      tabname: [this.$t('import.s1'), this.$t('import.s2'), this.$t('import.s3'), this.$t('import.s4'), this.$t('import.s5')],
      nodata: 0,
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
      table1: [],
      table2: [],
      table3: [],
      table4: [],
      table5: [],
      skudata: [],
      tableloading1: false,
      expands: [],
      pagesize: 25,
      currentPage: 1,
      pagingtotal: 0,
      pagingtotal1: 0,
      pagingtotal2: 0,
      pagingtotal3: 0,
      pagingtotal4: 0,
      pagingtotal5: 0,
    }
  },

  mounted(){
    this.getChannelLists()
    this.reloadPage()
  },

  methods: {

    /**
     * 切换tabs
     */
    changetabs: function(){
      let that = this
      that.expands = []
      that.skudata = []
      that.currentPage = 1
      if(that.activeName == 'first'){
        that.getTabsLists('4,5')
        that.pagingtotal = that.pagingtotal5
      }
      if(that.activeName == 'second'){
        that.getTabsLists(1)
        that.pagingtotal = that.pagingtotal2
      }
      if(that.activeName == 'third'){
        that.getTabsLists(2)
        that.pagingtotal = that.pagingtotal3
      }
      if(that.activeName == 'four'){
        that.getTabsLists('0,1,2,6')
        that.pagingtotal = that.pagingtotal4
      }
      if(that.activeName == 'five'){
        that.getTabsLists(3)
        that.pagingtotal = that.pagingtotal5
      }
    },
    
    /**
     * 分页
     */
    handleSizeChange: function(val){
      let that = this
      that.pagesize = val
      if(that.activeName == 'first'){
        that.getTabsLists('4,5')
        that.pagingtotal = that.pagingtotal5
      }
      if(that.activeName == 'second'){
        that.getTabsLists(1)
        that.pagingtotal = that.pagingtotal2
      }
      if(that.activeName == 'third'){
        that.getTabsLists(2)
        that.pagingtotal = that.pagingtotal3
      }
      if(that.activeName == 'four'){
        that.getTabsLists('0,1,2,6')
        that.pagingtotal = that.pagingtotal4
      }
      if(that.activeName == 'five'){
        that.getTabsLists(3)
        that.pagingtotal = that.pagingtotal5
      }
    },

    /**
     * 翻页
     */
    handleCurrentChange: function(val){
      let that = this
      if(that.activeName == 'first'){
        that.getTabsLists('4,5')
        that.pagingtotal = that.pagingtotal1
      }
      if(that.activeName == 'second'){
        that.getTabsLists(1)
        that.pagingtotal = that.pagingtotal2
      }
      if(that.activeName == 'third'){
        that.getTabsLists(2)
        that.pagingtotal = that.pagingtotal3
      }
      if(that.activeName == 'four'){
        that.getTabsLists('0,1,2,6')
        that.pagingtotal = that.pagingtotal4
      }
      if(that.activeName == 'five'){
        that.getTabsLists(3)
        that.pagingtotal = that.pagingtotal5
      }
      that.currentPage = val
    },

    /**
     * 页面重载
     */
    reloadPage: function(){
      let that = this
      that.getTabsLists('4,5') //正常
      that.getTabsLists(1) //暂停
      that.getTabsLists(2) //删除
      that.getTabsLists('0,1,2,6') //处理中
      that.getTabsLists(3) //失败
    },

    /**
     * 获取渠道列表
     */
    getChannelLists: function(){
      let that = this
      let url = that.API_URL + '/v3/importlink/statistics/channelList?taskid=' + that.current.taskid
      $.ajax({
        url: url,
        type: "GET",
        dataType: "json",
        changeOrigin: true,
        contentType: "application/json",
        success: function(data) {
          console.log('getChannelLists', data)
          for(let i=0; i<data.results.length; i++){
            if(data.results[i] * 1 == 1){
              that.channel.taobao = true
            }
            if(data.results[i] * 1 == 2){
              that.channel.tmall = true
            }
            if(data.results[i] * 1 == 3){
              that.channel.jd = true
            }
            if(data.results[i] * 1 == 30){
              that.channel.pdd = true
            }
            if(data.results[i] * 1 == 10){
              that.channel.vipcom = true
            }
            if(data.results[i] * 1 == 17){
              that.channel.kaola = true
            }
            if(data.results[i] * 1 == 45){
              that.channel.douyin = true
            }
          }
          if(that.channel.taobao == false 
            && that.channel.tmall == false 
            && that.channel.jd == false
            && that.channel.pdd == false
            && that.channel.vipcom == false
            && that.channel.kaola == false
            && that.channel.douyin == false){
            that.nochannel = true
          }
        },
        error: function(response) {
          console.log('getChannelLists',response)
        }
      })
    },

    /**
     * 检查是否有上传的url数据
     */
    getUrls: function(){
      let _urls = JSON.parse(localStorage.getItem("temp_uploadurls")).val
      if(_urls.length > 0){
        this.showdata = true
        let _lists = []
        for(let i=0; i<_urls.length; i++){
          let _obj = {
            id: 1000 + (i+1),
            insert: '2022-05-01 15:00',
            url: _urls[i],
            status: '处理中'
          }
          _lists.push(_obj)
        }
        this.urlsdata = _lists
      }
    },

    /**
     * 点击上传
     */
    onClickUpload: function(){
      this.showchannelicon = true
      this.showdialog = true
    },

    /**
     * 监听输入事件
     */
    onInputChange: function(){
      let that = this
      let _urls = that.uploadurls.split(/[(\r\n\s)\r\n\s]+/).filter(Boolean)
      that.urlslength = _urls.length >= 50 ? 50 : _urls.length
      if(_urls.length >= 50){
        let _uploadurls = _urls.slice(0, 50)
        that.uploadurls = _uploadurls.join('\n')
      }
    },
    
    /**
     * 上传
     */
    uploadSku: function(){
      this.importloading = true
      this.importLists()
    },

    /**
     * 导入链接
     */
    importLists: function(){
      let that = this
      let url = that.API_URL + '/v3/importlink/statistics/addlink'
      let _query = {
        taskid: that.current.taskid,
        linkList: that.uploadurls.split(/[(\r\n\s)\r\n\s]+/)
      }
      $.ajax({
        url: url,
        type: "POST",
        dataType: "json",
        changeOrigin: true,
        contentType: "application/json",
        data: JSON.stringify(_query),
        success: function(data) {
          console.log('importLists',data)
          that.importloading = false
          that.updatesuccessful = true
          that.reloadPage()
        },
        error: function(response) {
          console.log('importLists',response)
        }
      })      
    },

    /**
     * 展开
     */
    getProductList: function(row){
      let that = this
      let url = that.API_URL + '/v3/importlink/statistics/linkDetailList'
      let _query = {
        taskid: that.current.taskid,
        ImportID: row.ImportID
      }

      let _c = that.expands
      if(row.index == _c[0]) return
      that.expands = []
      that.expands.push(row.index)

      that.tableloading1 = true
      $.ajax({
        url: url,
        type: "GET",
        dataType: "json",
        changeOrigin: true,
        contentType: "application/json",
        data: _query,
        success: function(data) {
          that.skudata[row.index] = data.results
          that.tableloading1 = false
        },
        error: function(response) {
          console.log('getProductList',response)
        }
      })
    },

    /**
     * 获取各个tab列表
     */
    getTabsLists: function(status){
      let that = this
      let url = that.API_URL + '/v3/importlink/statistics/linkList'
      let _query = {}
      if(status == '4,5' || status == 3 || status == '0,1,2,6'){
        _query = {
          taskid: that.current.taskid,
          status: status,
          page: that.currentPage,
          size: that.pagesize
        }
      }else{
        _query = {
          taskid: that.current.taskid,
          Ostatus: status,
          page: that.currentPage,
          size: that.pagesize
        }        
      }
      $.ajax({
        url: url,
        type: "GET",
        // dataType: "json",
        // changeOrigin: true,
        // contentType: "application/json",
        data: _query,
        success: function(data) {
          console.log('getTabsLists',data)
          that.getTabsStatus(status, data)
        },
        error: function(response) {
          console.log('getTabsLists',response)
        }
      })
    },

    /**
     * 获取tab状态
     */
    getTabsStatus: function(status, res){
      let that = this
      if(status == '4,5'){
        if(res.results[1].length > 0){
          that.show1 = true
          that.tabname[0] = that.$t('import.s1')+' ('+res.results[0][0].Count+')'
          that.table1 = that.formatLists(res.results[1])
          that.pagingtotal1 = res.results[0][0].Count
          if(that.activeName == 'first'){
            that.pagingtotal = res.results[0][0].Count
          }
          that.nodata = 1
        }else{
          that.show1 = false
          that.tabname[0] = that.$t('import.s1')+' (0)'
          that.table1 = []
        }
      }
      if(status == '0,1,2,6'){
        if(res.results[1].length > 0){
          that.show4 = true
          that.tabname[3] = that.$t('import.s4')+' ('+res.results[0][0].Count+')'
          that.table4 = that.formatLists(res.results[1])
          that.pagingtotal4 = res.results[0][0].Count
          if(that.activeName == 'four'){
            that.pagingtotal = res.results[0][0].Count
          }
          that.nodata = 1
        }else{
          that.show4 = false
          that.tabname[3] = that.$t('import.s4')+' (0)'
          that.table4 = []
        }
      }
      if(status == 3){
        if(res.results[1].length > 0){
          that.show5 = true
          that.tabname[4] = that.$t('import.s5')+' ('+res.results[0][0].Count+')'
          that.table5 = that.formatLists(res.results[1])
          that.pagingtotal5 = res.results[0][0].Count
          if(that.activeName == 'five'){
            that.pagingtotal = res.results[0][0].Count
          }
          that.nodata = 1
        }else{
          that.show5 = false
          that.tabname[4] = that.$t('import.s5')+' (0)'
          that.table5 = []
        }
      }
      if(status == 1){
        // 已暂停
        if(res.results[1].length > 0){
          that.show2 = true
          that.tabname[1] = that.$t('import.s2')+' ('+res.results[0][0].Count+')'
          that.table2 = that.formatLists(res.results[1])
          that.pagingtotal2 = res.results[0][0].Count
          if(that.activeName == 'second'){
            that.pagingtotal = res.results[0][0].Count
          }
          that.nodata = 1
        }else{
          that.show2 = false
          that.tabname[1] = that.$t('import.s2')+' (0)'
          that.table2 = []
        }
      }
      if(status == 2){
        // 已删除
        if(res.results[1].length > 0){
          that.show3 = true
          that.tabname[2] = that.$t('import.s3')+' ('+res.results[0][0].Count+')'
          that.table3 = that.formatLists(res.results[1])
          that.pagingtotal3 = res.results[0][0].Count
          that.nodata = 1
        }else{
          that.show3 = false
          that.tabname[2] = that.$t('import.s3')+' (0)'
          that.table3 = []
        }
      }
      // if(that.show1 || that.show2 || that.show3 || that.show4 || that.show5){
      //   that.nodata = 1
      // }else{
      //   that.nodata = 2
      // }
      // if(that.show1 == false && that.show2 == false &&  that.show3 == false &&  that.show4 == false &&  that.show5 == false){
      //   that.nodata = 2
      // }
      
    },

    /**
     * 格式化数据列表
     */
    formatLists: function(data){
      let that = this
      let _lists = data
      _lists.forEach((item, index) => {
        item.channelicon = that.setChannel(item.ChannelName).src
        item.pageprice = item.minFinalPrice == item.maxFinalPrice ? item.maxFinalPrice : item.maxFinalPrice + '-' + item.maxFinalPrice
        item.MarginPercent = (item.MarginPercent * 100).toFixed(2) + "%"
        item.authorize = item.IsAuthor/1 === 0 ? that.$t('dsfx.t53') : that.$t('dsfx.t52')
        item.index = index
        item.inserttime = that.$moment(item.InsertTime).local().format('YYYY-MM-DD HH:mm')
      })
      return _lists
    },

    /**
     * 查看详情
     */
    viewUrlDetail: function(mid, name){
      console.log(mid, name)
    },

    /**
     * 暂停 & 删除
     */
    updateStatus: function(row, status){
      let that = this
      let url = that.API_URL + '/v3/importlink/statistics/updatelinkStatus'
      let _query = {
        ImportID: row.ImportID,
        Status: status
      }
      $.ajax({
        url: url,
        type: "POST",
        dataType: "json",
        changeOrigin: true,
        contentType: "application/json",
        data: JSON.stringify(_query),
        success: function(data) {
          console.log('updateStatus', data)
          that.$message({
            message: data.results,
            type: 'success'
          })
          that.reloadPage()
        },
        error: function(response) {
          console.log('updateStatus',response)
        }
      })
    },

  }
}
</script>